export default __webpack_public_path__ + "static/media/aira_2.5955d1fe.PNG";